import { cn } from '@/lib/utils';
import { Label } from '@/shared/components/ui/label';
import type { CheckBoxProps } from './CheckBox.types';

const CheckBox = ({
  id,
  label,
  checked = false,
  disabled = false,
  value,
  customCheck = '',
  customLabel = '',
  accentColor,
  onChange,
}: CheckBoxProps) => {
  const inputId = id || `checkbox-${label.replace(/\s+/g, '-')}`;

  return (
    <div className="flex flex-row items-center gap-x-4">
      <div
        className="relative flex flex-row gap-[8px] cx-preferences"
        data-disabled={disabled || undefined}
      >
        <input
          type="checkbox"
          id={inputId}
          className={cn('peer', customCheck)}
          disabled={disabled}
          checked={checked}
          onChange={onChange}
          value={value}
          style={accentColor ? { accentColor } : undefined}
        />
        <Label htmlFor={inputId} className={cn('title3medium', customLabel)}>
          {label}
        </Label>
      </div>
    </div>
  );
};

export default CheckBox;
